import { render, staticRenderFns } from "./WorkTabsPicker.vue?vue&type=template&id=8064a832&scoped=true"
import script from "./WorkTabsPicker.vue?vue&type=script&lang=js"
export * from "./WorkTabsPicker.vue?vue&type=script&lang=js"
import style0 from "./WorkTabsPicker.vue?vue&type=style&index=0&id=8064a832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8064a832",
  null
  
)

export default component.exports